export default "__VITE_ASSET__j_LvU9Ml__"